export default function containsInvalidEmailAddressCharacters(emailAddress: string) {
  return Array.from(emailAddress, (c) => c.charCodeAt(0)).some((c: number) => c <= 40 || c >= 177);
}
